import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';

class MatterCategoriesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      loaded: 0,
      redirect_url: false,
      category_id: null,
      percent: null,
      lista_categorias: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionardCategoria = this.adicionardCategoria.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.categorias) && Array.isArray(newProps.lista_categorias) && this.state.loaded === 0) {
      this.setState({dados: newProps.categorias, lista_categorias: newProps.lista_categorias, loaded: 1});
    }
  }
  
  adicionardCategoria(event) {
    event.preventDefault();
    var dados_salvar = {
      category_id: this.state.category_id,
      percent: this.state.percent,
      matter_id: this.props.matter_id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/categoria', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/categoria/materia/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var category_matter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa categoria?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/categoria/' + category_matter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(category_matter_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(category_matter_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == category_matter_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionardCategoria}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Categoria:</label>
            <Select
              className="form-field-name"
              name="category_id"
              value={this.state.category_id}
              searchable={true}
              placeholder={'Selecionar Categoria'}
              onChange={this.handleSelectChange.bind(this, 'category_id')}
              options={this.state.lista_categorias}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Percentual:</label>
          <input type="percent" name="percent" className="form-control" placeholder="Apenas números" value={this.state.percent} onChange={this.handleChange.bind(this, 'percent')} />
        </div>
      </div>
    </div>
      <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar categoria</button>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há categorias cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="categoria" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Categoria</TableHeaderColumn>

    <TableHeaderColumn dataField="percent" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Percentual</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MatterCategoriesTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MatterCategoriesEditTab.js